import axios from 'axios';

import store from '../store'

let headers = {};
if(store.state.token && store.getters.isAuthenticated) {
  headers.Authorization = `Token ${store.state.token}`
}

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: headers,
  validateStatus: function (status) {
    return (status >= 200 && status < 300) || status == 400 || status == 401; // 400 is for jwt auth
  },
});
